export enum ESupportedLocales {
  EN = 'en',
  PL = 'pl',
  UK = 'uk',
}
